import { render, staticRenderFns } from "./ot-contract-amendments-form.vue?vue&type=template&id=14d69604&scoped=true&"
import script from "./ot-contract-amendments-form.vue?vue&type=script&lang=ts&"
export * from "./ot-contract-amendments-form.vue?vue&type=script&lang=ts&"
import style0 from "./ot-contract-amendments-form.vue?vue&type=style&index=0&id=14d69604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d69604",
  null
  
)

export default component.exports